import React from 'react';

const LoggedOutView: React.FC = () => {
    return <p>Google One Tap will appear automatically if you're eligible.</p>;
};

export default LoggedOutView;